import React from "react";

import {
  FaUserGraduate,
  FaGlobe,
  FaBook,
  FaPaperPlane,
} from "react-icons/fa";

import whyImg from "../assets/why.jpg";

const WhyChoose = () => {
  return (
    <section className="w-full bg-[#f7f9fc] py-20">

      <div className="max-w-7xl mx-auto px-5 md:px-10">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch">

          {/* LEFT SIDE */}
          <div className="relative">

            {/* BACKGROUND SHAPE */}
            <div className="absolute top-5 left-5 w-full h-full bg-[#0B4F9C]/10 rounded-[35px]"></div>

            {/* IMAGE CARD */}
            <div className="relative bg-white rounded-[35px] shadow-2xl p-5 h-full flex items-center justify-center">

              <div className="relative flex justify-center items-center">

                <img
                  src={whyImg}
                  alt="ST. JOSEPH'S SCHOOL"
                  className="
    w-full
    h-auto
    object-contain
    rounded-[25px]
    max-h-[700px]
    md:max-h-[650px]
  "
                />

              </div>

            </div>

          </div>

          {/* RIGHT SIDE */}
          <div className="bg-white rounded-[35px] shadow-2xl p-8 md:p-12 flex flex-col justify-between h-full">

            {/* TOP CONTENT */}
            <div>

              <span className="text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

                Why Choose Us

              </span>

              <h2 className="text-4xl md:text-5xl font-extrabold text-[#072F5F] leading-tight mt-4">

                WHY CHOOSE
                <span className="block text-[#0B4F9C]">
                  OUR SCHOOL?
                </span>

              </h2>

              <p className="text-gray-600 text-lg leading-9 mt-8">

                A leading residential school focused on
                excellence, leadership, innovation and
                holistic development with modern learning
                methods and world-class facilities.

              </p>

            </div>

            {/* FEATURE CARDS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-12">

              {/* CARD */}
              <div className="bg-[#f7f9fc] rounded-3xl p-7 hover:shadow-xl transition-all duration-500 border border-gray-100">

                <div className="w-16 h-16 rounded-2xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mb-6">

                  <FaBook />

                </div>

                <h3 className="text-2xl font-bold text-[#072F5F] leading-snug">

                  Progressive Education

                </h3>

              </div>

              {/* CARD */}
              <div className="bg-[#f7f9fc] rounded-3xl p-7 hover:shadow-xl transition-all duration-500 border border-gray-100">

                <div className="w-16 h-16 rounded-2xl bg-[#D4A017]/10 text-[#D4A017] flex items-center justify-center text-3xl mb-6">

                  <FaGlobe />

                </div>

                <h3 className="text-2xl font-bold text-[#072F5F] leading-snug">

                  SmartClass Education

                </h3>

              </div>

              {/* CARD */}
              <div className="bg-[#f7f9fc] rounded-3xl p-7 hover:shadow-xl transition-all duration-500 border border-gray-100">

                <div className="w-16 h-16 rounded-2xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mb-6">

                  <FaPaperPlane />

                </div>

                <h3 className="text-2xl font-bold text-[#072F5F] leading-snug">

                  Excellent Infrastructure

                </h3>

              </div>

              {/* CARD */}
              <div className="bg-[#f7f9fc] rounded-3xl p-7 hover:shadow-xl transition-all duration-500 border border-gray-100">

                <div className="w-16 h-16 rounded-2xl bg-[#D4A017]/10 text-[#D4A017] flex items-center justify-center text-3xl mb-6">

                  <FaUserGraduate />

                </div>

                <h3 className="text-2xl font-bold text-[#072F5F] leading-snug">

                  Shaping Bright Future

                </h3>

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default WhyChoose;